class CounterAnimation {
  constructor() {
    this.counters = document.querySelectorAll('.counter-animated');
    this.progressCircles = document.querySelectorAll('.counter-section__progress-dashed');
    this.animationDuration = 2500; // 2.5 seconds
    this.init();
  }

  init() {
    if (this.counters.length === 0 && this.progressCircles.length === 0) return;
    
    // Set up intersection observer
    this.setupIntersectionObserver();
  }

  setupIntersectionObserver() {
    const options = {
      threshold: 0.3, // Trigger when 30% of element is visible
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('counted')) { 
          // Add 0.5 second delay before starting animation
          setTimeout(() => {
            if (entry.target.classList.contains('counter-animated')) {
              this.animateCounter(entry.target);
            } else if (entry.target.classList.contains('counter-section__progress-dashed')) {
              this.animateProgressCircle(entry.target);
            }
          }, 500);
          entry.target.classList.add('counted');
        }
      });
    }, options);

    this.counters.forEach(counter => {
      observer.observe(counter);
      // Initially set to 0 and hidden
      counter.style.opacity = '0';
      counter.textContent = '0%';
    });

    this.progressCircles.forEach(circle => {
      observer.observe(circle);
      // Initially set progress to 0
      circle.style.setProperty('--progress', '0');
    });
  }

  animateCounter(element) {
    const target = parseInt(element.dataset.target);
    const startTime = performance.now();
    
    // Fade in the element
    element.style.transition = 'opacity 0.5s ease-in-out';
    element.style.opacity = '1';

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / this.animationDuration, 1);
      
      // Use easeOutQuart for smooth deceleration
      const easeProgress = 1 - Math.pow(1 - progress, 4);
      const currentValue = Math.floor(easeProgress * target);
      
      element.textContent = `${currentValue}%`;
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // Ensure we end exactly on target
        element.textContent = `${target}%`;
      }
    };

    requestAnimationFrame(animate);
  }

  animateProgressCircle(element) {
    const targetPercentage = parseInt(element.dataset.percentage);
    const targetProgress = targetPercentage / 100; // Convert to 0-1 range
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / this.animationDuration, 1);
      
      // Use easeOutQuart for smooth deceleration
      const easeProgress = 1 - Math.pow(1 - progress, 4);
      const currentProgress = easeProgress * targetProgress;
      
      element.style.setProperty('--progress', currentProgress.toString());
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // Ensure we end exactly on target
        element.style.setProperty('--progress', targetProgress.toString());
      }
    };

    requestAnimationFrame(animate);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CounterAnimation());
} else {
  new CounterAnimation();
}